import React from "react";
import CategoryMenu from "./category-menu";
import HorizontalCategoryMenu from "./horizontal-category-menu";
import DropdownMenu from "./dropdown-menu";

const MegaMenu = ({ data, setShowOverlay, className, embedHeader }) => {
	return (
		<DropdownMenu data={data} setShowOverlay={setShowOverlay} className={className}
			childrenClass="mega-menu-container" embedHeader={embedHeader}>
			{data.isHorizontal
				? <HorizontalCategoryMenu data={data.links} />
				: <CategoryMenu data={data.links} />}
		</DropdownMenu>
	);
};

export default MegaMenu;